// CSRF double-submit. Extracted from api/client.ts (verbatim). The `csrfToken`
// singleton lives HERE and only here — one ESM module instance; every read/write
// goes through these functions, so there is exactly one cached token process-wide.
import { API_BASE } from './constants';
import { ApiError } from './errors';

// ── CSRF double-submit: GET /csrf sets a readable cookie AND returns the token;
// we echo it back in X-CSRF-Token on mutations. Cached in-memory; refreshed once
// on a csrf 403 (rotation/expiry). ─────────────────────────────────────────────
let csrfToken: string | null = null;

export async function ensureCsrf(): Promise<string> {
  if (csrfToken) return csrfToken;
  const res = await fetch(`${API_BASE}/csrf`, { credentials: 'include' });
  if (!res.ok) throw new ApiError('Could not establish a secure session.', res.status);
  const data = (await res.json()) as { csrfToken: string };
  csrfToken = data.csrfToken;
  return csrfToken;
}

export function clearCsrf(): void {
  csrfToken = null;
}

/** Test-only: drop the cached CSRF token between cases. */
export function _resetClientStateForTests(): void {
  csrfToken = null;
}
